import { createStyles, withStyles, WithStyles } from "@mui/styles";
import classNames from "classnames";
import * as React from "react";


const styles = () => createStyles({
    fakeSmallIconButton: {
        padding: "3px",
        fontSize: "1.125rem"
    },
});

interface IProps {
    size: "small",
    className?: string;
}

type Props = IProps & WithStyles<typeof styles>;

const MuiFakeIconButton: React.FC<Props> = (props) => {
    const {
        size,
        className,
        classes,
        children
    } = props;

    const btnClasses = classNames({
        [classes.fakeSmallIconButton]: size == "small",
        [className]: className
    });
    return (
        <span className={btnClasses}>
            {children}
        </span>
    );
};

export default withStyles(styles)(MuiFakeIconButton);
